import { useCallback } from "react";
import { useAppSelector } from "@redux/hooks";
import { useApiAction } from "@shared-kernel/primary/shared/api-errors/use-api-action";
import { useResetWhenSettled } from "@shared-kernel/primary/shared/request-state/use-reset-when-settled";
import {
  resetResetUserPassword,
  resetUserPassword,
} from "@user-management-context/write/application/use-cases/user-password-reset/reset-user-password";
import { selectUserPasswordReset } from "@user-management-context/write/application/use-cases/user-password-reset/selectors/user-password-reset-selectors";

export const useUserPasswordReset = () => {
  const run = useApiAction();
  const { processing } = useAppSelector(selectUserPasswordReset);
  useResetWhenSettled(processing, resetResetUserPassword);

  // Sans feedback : l'écran affiche la page de vérification de l'email quelle que soit l'issue, comme avant
  const requestPasswordReset = useCallback(
    async (body: { email: string }): Promise<void> => {
      await run(resetUserPassword(body));
    },
    [run],
  );

  return { requestPasswordReset };
};
